<template>
  <section>
    <span>
      <b-button
        :icon-right="iconEmail"
        :class="cssColor"
        :reads="reads"
        :unreads="unReads"
        @click.prevent="openBox(ids)"
      />
    </span>
  </section>
</template>

<script>
export default {
  name: 'MailBox',
  computed: {
    commentsForRead () {
      return this.$attrs.commentsForRead
    },
    reads () {
      return this.$attrs.countReads
    },
    unReads () {
      return this.$attrs.countUnReads > 0 ? this.$attrs.countUnReads : null
    },
    ids () {
      const {
        id,
        customerOrderCode
      } = this.$attrs

      return {
        id,
        customerOrderCode
      }
    },
    cssColor () {
      return (!this.commentsForRead && this.reads === 0)
        ? 'local-lm-btn-row'
        : 'local-lm-btn-row-orange'
    },
    iconEmail () {
      return (!this.commentsForRead && this.reads > 0 && !this.unReads)
        ? 'email-open-outline'
        : 'email-outline'
    }
  },
  methods: {
    openBox (ids) {
      if (Object.keys(ids).length === 0) return false

      this.$store.dispatch('messages/launchMessageModal', ids)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MailBox.vue